'use client';

import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { UnauthQueryOptions } from '@/api';
import { DesktopSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';

import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchSectionShell } from '../SearchSectionShell';
import { LocalMarketList } from './LocalMarketList';
import { SearchMarketCardSkeletonList } from './SearchMarketCardSkeleton';

interface LocalMarketSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
}

export function LocalMarketSearch({
  keyword,
  page,
  onPageChange,
}: LocalMarketSearchProps) {
  const { data, isLoading } = useQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/query/local-market']({
      query: {
        searchKeyword: keyword,
        page,
        size: PAGE_SIZE,
      },
    }),
    placeholderData: keepPreviousData,
  });

  const meta = buildPaginationMeta(data?.context?.totalCount ?? 0);

  return (
    <DesktopPageShell
      className="mt-20 w-full mobile-tablet:mt-0"
      rightAside={<DesktopSideAdBanner />}
    >
      <SearchSectionShell
        meta={meta}
        page={page}
        pageSize={PAGE_SIZE}
        onPageChange={onPageChange}
      >
        {isLoading ? (
          <SearchMarketCardSkeletonList count={PAGE_SIZE} />
        ) : (
          <LocalMarketList items={data?.context?.contents ?? []} />
        )}
      </SearchSectionShell>
    </DesktopPageShell>
  );
}
